import type {ClosetItem} from '@/types';
import styles from './Card.module.css';

interface ListCardProps {
  item: ClosetItem;
  showMember?: boolean;
  memberName?: string;
  onClick?: () => void;
}

export function ListCard({item, showMember, memberName, onClick}: ListCardProps) {
  return (
    <div className={styles.listCard} onClick={onClick}>
      <div className={styles.listImage}>
        <span>{item.emoji}</span>
      </div>
      <div className={styles.listDetails}>
        <div className={styles.listBrand}>{item.brand}</div>
        <div className={styles.listName}>{item.name}</div>
        <div className={styles.listMeta}>
          <span>{item.category}</span>
          <span>·</span>
          <span>{formatDate(item.date)}</span>
          {showMember && memberName && (
            <>
              <span>·</span>
              <span>{memberName}</span>
            </>
          )}
        </div>
      </div>
      <div className={styles.listPrice}>${formatPrice(item.price)}</div>
    </div>
  );
}

function formatPrice(price: number): string {
  return price.toLocaleString('en-US', {
    minimumFractionDigits: price % 1 ? 2 : 0,
  });
}

function formatDate(dateStr: string): string {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
